/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Empty component for WidgetSubscriberMaxCosts
 *
 * @author Fedorov Maxim
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.0.1
 */

import { Fragment } from 'react';

import { icons } from '../../../../../../assets';
import { FlexMiddleStyled } from '../../../../../../components/common/Block/Flexbox';
import { ImgStyled } from '../../../../../../components/common/Block/Img';
import { LayoutBoxStyled, LayoutStyled } from '../../../../../../components/common/Block/Layout';
import IPageDashboardTranslation from '../../../../../../modules/internationalization/types/pages/dashboard/dashboard';
import { colors } from '../../../../../../theme';
import { WidgetHelpTextStyled, WidgetHelpTitleStyled } from '../../styled/WidgetHelpStyled';

export interface IWidgetSubscriberMaxCostsEmptyProps {
    translation: IPageDashboardTranslation;
}

const WidgetSubscriberMaxCostsEmpty = (props: IWidgetSubscriberMaxCostsEmptyProps) => {
    const translation = props.translation.widgets.subscriberMaxCosts.empty;
    return (
        <Fragment>

            <FlexMiddleStyled className="mb-3">
                <LayoutBoxStyled
                    background={colors.backgroundColorModal}
                    borderRadius="100%"
                    height="72px"
                    padding="20px"
                    width="72px"
                >
                    <ImgStyled
                        className="medium"
                        height="32px"
                        src={icons.balanceMediumIcon}
                        width="32px"/>
                </LayoutBoxStyled>
            </FlexMiddleStyled>

            <LayoutStyled className="mb-1 t-center">
                <WidgetHelpTitleStyled>
                    {translation.title}
                </WidgetHelpTitleStyled>
            </LayoutStyled>

            <LayoutStyled className="mb-4 t-center">
                <WidgetHelpTextStyled>
                    <div dangerouslySetInnerHTML={({ __html: translation.helpText })}/>
                </WidgetHelpTextStyled>
            </LayoutStyled>

        </Fragment>
    );
};

export default WidgetSubscriberMaxCostsEmpty;
